module.exports = __webpack_public_path__ + "img/flow2-1.9d82ea88.png";